import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, BACKEND, errMsg } from "@/lib/api";
import { Switch } from "@/components/ui/switch";
import { Spinner } from "@/components/Brand";
import { GoldBtn, PageTitle } from "@/pages/admin/AdminLayout";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";

const FIELDS = [
  ["site_name", "Nama website", false], ["tagline", "Tagline", false], ["about", "Tentang (tampil di beranda)", true],
  ["contact_email", "Email kontak", false], ["contact_phone", "Telepon/WhatsApp", false], ["address", "Alamat", false],
  ["bank_info", "Rekening tujuan transfer", true], ["payment_instructions", "Instruksi pembayaran", true],
];

export default function SettingsAdmin() {
  const [f, setF] = useState(null);
  const [gw, setGw] = useState(null);
  useEffect(() => {
    api.get("/settings").then((r) => setF(r.data)).catch((e) => toast.error(errMsg(e)));
    api.get("/payments/midtrans/config").then((r) => setGw(r.data)).catch(() => {});
  }, []);
  const save = async (e) => {
    e.preventDefault();
    try {
      const { data } = await api.put("/admin/settings", f);
      setF(data);
      toast.success("Pengaturan website disimpan");
    } catch (err) {
      toast.error(errMsg(err));
    }
  };
  if (!f) return <Spinner />;
  return (
    <div className="max-w-3xl">
      <PageTitle title="Pengaturan Website" desc="Identitas, kontak, dan informasi pembayaran." />
      <form onSubmit={save} className="card-premium space-y-4 p-6" data-testid="settings-form">
        {FIELDS.map(([k, label, long]) => (
          <div key={k}><Label>{label}</Label>
            {long ? <Textarea rows={3} value={f[k] || ""} onChange={(e) => setF({ ...f, [k]: e.target.value })} data-testid={`settings-${k}`} />
              : <Input value={f[k] || ""} onChange={(e) => setF({ ...f, [k]: e.target.value })} data-testid={`settings-${k}`} />}
          </div>
        ))}
        <div className="space-y-3 rounded-lg border border-amber-300 bg-amber-50/50 p-4" data-testid="gateway-settings">
          <div className="flex items-center gap-3"><Switch checked={!!f.payment_gateway_enabled} onCheckedChange={(v) => setF({ ...f, payment_gateway_enabled: v })} data-testid="settings-gateway-switch" /><Label>Aktifkan pembayaran online Midtrans</Label></div>
          <p className="text-xs text-slate-600">Status kunci Midtrans: <b data-testid="gateway-key-status">{gw ? (gw.client_key_invalid ? "Client Key salah (berisi Server Key) — pembayaran online dinonaktifkan" : gw.client_key ? `terpasang (${gw.production ? "LIVE" : "sandbox"})` : "belum diisi") : "..."}</b>. Akses paket terbuka otomatis hanya setelah Midtrans mengonfirmasi pembayaran (settlement). Transfer manual tetap tersedia.</p>
          <p className="break-all text-xs text-slate-600">URL Notifikasi untuk dashboard Midtrans (Settings → Configuration → Payment Notification URL): <code className="rounded bg-white px-1" data-testid="gateway-webhook-url">{`${BACKEND}/api/payments/midtrans/notification`}</code></p>
        </div>
        <GoldBtn type="submit" data-testid="settings-save-btn">Simpan Pengaturan</GoldBtn>
      </form>
    </div>
  );
}
